<div style="min-width: 900px">
  <div [froalaEditor]="froalaOptions" [(froalaModel)]="model"></div>
</div>

